import MembershipShields from "@/components/MembershipShields";
import ResponsibleBanner from "@/components/ResponsibleBanner";
import { Crown } from "lucide-react";

export default function MembershipPage() {
  return (
    <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-14 space-y-12">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-smasher-orange mb-2"><Crown className="w-4 h-4" /> MEMBERSHIP</div>
        <h1 className="font-heading font-black uppercase text-4xl sm:text-6xl text-gradient-gold">Choose Your Weapon</h1>
        <p className="text-slate-400 mt-3 max-w-2xl mx-auto">Two ways to smash the books. Every plan is built around education, discipline and information — designed to grow with more member benefits over time.</p>
      </div>

      <MembershipShields />

      <div className="grid sm:grid-cols-2 gap-6">
        <div className="panel p-6">
          <h3 className="font-heading font-bold text-xl text-smasher-gold mb-2">What membership is</h3>
          <p className="text-sm text-slate-400 leading-relaxed">Access to Sportsbook Smasher educational content, daily sports information, upcoming events, news and strategy education. Membership is about learning to analyze the game — not a promise of guaranteed winnings.</p>
        </div>
        <div className="panel p-6">
          <h3 className="font-heading font-bold text-xl text-smasher-gold mb-2">Built to grow</h3>
          <p className="text-sm text-slate-400 leading-relaxed">The membership architecture is designed so additional benefits — premium analysis, member dashboards, alerts and more — can be added over time as the platform expands.</p>
        </div>
      </div>

      <ResponsibleBanner />
    </div>
  );
}
